(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (function () {
    const content = document.querySelector('.blog-post-layout__main rte-formatter');
    const toc = document.getElementById('blog-post-toc');
    const list = document.getElementById('blog-post-toc-list');
    const hideBtn = document.querySelector('.js--hide-toc__list');
    const showBtn = document.querySelector('.js--show-toc__list');

    if (!content || !toc || !list || !hideBtn || !showBtn) return;

    const headings = content.querySelectorAll('h2, h3, .ui-accordion-header, .schema-faq-question');
    if (headings.length === 0) return;

    let currentH2Item = null;
    let currentSublist = null;

    function setTocVisibility(isVisible) {
      if (isVisible) {
        list.classList.remove('blog-post-toc__list--not-visible');
        hideBtn.style.display = 'inline';
        showBtn.style.display = 'none';
      } else {
        list.classList.add('blog-post-toc__list--not-visible');
        hideBtn.style.display = 'none';
        showBtn.style.display = 'inline';
      }
    }

    hideBtn.addEventListener('click', function (event) {
      event.preventDefault();
      setTocVisibility(false);
    });

    showBtn.addEventListener('click', function (event) {
      event.preventDefault();
      setTocVisibility(true);
    });

    headings.forEach(function (heading, index) {
      const id = 'toc-heading-' + index;
      heading.id = id;

      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent;

      if (heading.tagName === 'H2') {
        currentSublist = null;
        const li = document.createElement('li');
        li.appendChild(link);
        list.appendChild(li);
        currentH2Item = li;
      } else if ((heading.tagName === 'H3' || heading.classList.contains('ui-accordion-header') || heading.classList.contains('schema-faq-question')) && currentH2Item) {
        if (!currentSublist) {
          currentSublist = document.createElement('ul');
          currentSublist.className = 'blog-post-toc__sublist';
          currentH2Item.appendChild(currentSublist);
        }
        const li = document.createElement('li');
        li.appendChild(link);
        currentSublist.appendChild(li);
      }
    });

    if (list.children.length > 0) {
      toc.removeAttribute('hidden');
      toc.classList.remove('blog-post-toc--not-visible');

      const isDesktop = window.innerWidth >= 750;
      setTocVisibility(isDesktop);

      window.addEventListener('resize', function () {
        const isNowDesktop = window.innerWidth >= 750;
        setTocVisibility(isNowDesktop);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
